import type { TUnitOfTime } from '@feathr/blackbox';

export interface ITimeUnitOption {
  id: TUnitOfTime;
  value: string;
}

export const secondsPerUnit: Record<TUnitOfTime, number> = {
  weeks: 604800,
  days: 86400,
  hours: 3600,
  minutes: 60,
};

export const minimumDisplayValues: Record<TUnitOfTime, number> = {
  minutes: 5,
  hours: 1,
  days: 1,
  weeks: 1,
};

export function bestUnit(seconds: number): TUnitOfTime {
  if (seconds === 0) {
    return 'minutes';
  }
  const entry = Object.entries(secondsPerUnit).find(([, s]) => seconds % s === 0);
  return (entry?.[0] as TUnitOfTime) ?? 'minutes';
}

export function toDisplayValue(seconds: number, unit: TUnitOfTime): number {
  return Math.round(seconds / secondsPerUnit[unit]);
}

export function toSeconds(displayValue: number, unit: TUnitOfTime): number {
  return displayValue * secondsPerUnit[unit];
}

export function getTimeUnitOptions(): ITimeUnitOption[] {
  return [
    { id: 'minutes', value: 'minutes' },
    { id: 'hours', value: 'hours' },
    { id: 'days', value: 'days' },
    { id: 'weeks', value: 'weeks' },
  ];
}

export function getTimeUnitOptionValue(option: ITimeUnitOption): string {
  return option.value;
}
